import { createFileRoute } from '@tanstack/react-router';
import { Trans } from '@lingui/react/macro';
import { t } from '@lingui/core/macro';
import { useHighlights } from '../services/dataHooks';
import NotesListPage from '../components/NotesListPage';

export const Route = createFileRoute('/_app/notes')({
  component: NotesPage,
});

export default function NotesPage() {
  const { notes, isLoading, error, isError } = useHighlights(1, false);

  if (isError) {
    const errorMessage = error?.message || t`Error`;
    return (
      <div className="flex-center py-8">
        <div className="text-danger">
          <Trans>Error loading notes: {errorMessage}</Trans>
        </div>
      </div>
    );
  }

  return <NotesListPage notes={notes} isLoading={isLoading} />;
}
